import { baseApi } from "api/BaseApi";

import { AlertAndMailData } from "./alerts.type";

const ALERTS_BASE_URL = "alerts";

const alertsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    sendAlertAndMail: build.mutation<string, AlertAndMailData>({
      query: (body) => ({
        url: `${ALERTS_BASE_URL}/send_alert_and_mail/`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useSendAlertAndMailMutation } = alertsApi;
